import React from 'react';
import { Routes, Route, BrowserRouter as Router, } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage';
import TwoFactorAuth from './components/TwoFactorAuth';
import ProtectedRoute from './components/ProtectedRoute';
function App() {
  return (
   
 <Router>
      <Routes>
        <Route path="/" element={<TwoFactorAuth />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>




  );
}

export default App; // ✅ Required for correct import in index.js
